export const enFormBrechaGenero = {

    translation: {
        "Brecha de Género": "Gender Gap",

        // Expediente
        "Datos del expediente": "Case details",
        "Trae de HubSpot el DNI del negocio, y el email y el teléfono del contacto asociado": "Pulls the deal's ID number from HubSpot, plus the linked contact's email and phone",
        "No se ha encontrado ese número de negocio en HubSpot": "That business number was not found in HubSpot",
        "Datos de HubSpot introducidos": "HubSpot data filled in",
        "El negocio no tiene DNI en HubSpot: tecléalo a mano": "The deal has no ID number in HubSpot: type it in by hand",
        "Buscar un número de negocio...": "Search a business number...",
        "Buscar": "Search",
        "Introduce un número de negocio": "Enter a business number",
        "Ha ocurrido un error al buscar el número de negocio": "An error occurred while searching for the business number",

        // Solicitante y contacto
        "Datos del solicitante": "Applicant details",
        "Primer apellido": "First surname",
        "Segundo apellido": "Second surname",
        "La ficha no tiene el nombre desglosado: revisa apellidos y nombre": "This record has no split name: check surnames and first name",
        "Datos de contacto": "Contact details",
        "No van al impreso, pero quedan en el expediente": "Not printed on the form, but kept in the case file",
        "El teléfono introducido no es válido": "The phone number entered is not valid",

        // Complemento y pensiones
        "Complemento que se solicita": "Requested supplement",
        "Pensión de la que es titular": "Pension held",
        "Puedes marcar más de una": "You can tick more than one",
        "Jubilación": "Retirement",
        "Incapacidad permanente": "Permanent disability",
        "Viudedad": "Widowhood",
        "Fecha de jubilación": "Retirement date",
        "Si se deja vacía, ese hueco del impreso sale en blanco": "If left empty, that gap on the form stays blank",
        "Marca al menos una pensión de la que sea titular": "Tick at least one pension held",

        // Hijos y otro progenitor
        "Hijos y otro progenitor": "Children and other parent",
        "El otro progenitor es el mismo para todos los hijos": "The other parent is the same for every child",
        "Lo tecleas una vez y sus datos se copian en la columna de cada hijo del impreso": "You type it once and the details are copied into every child's column on the form",
        "Hijo": "Child",
        "Eliminar": "Remove",
        "Añadir hijo": "Add child",
        "Añade al menos un hijo": "Add at least one child",
        "El impreso solo admite 6 hijos": "The form only allows 6 children",
        "Fecha de nacimiento": "Date of birth",
        "Fecha resolución adopción": "Adoption resolution date",
        "Otro progenitor de este hijo": "This child's other parent",
        "Copiar del hijo anterior": "Copy from previous child",
        "Progenitor copiado del hijo anterior": "Parent copied from the previous child",
        "¿No existe o ha fallecido?": "Does not exist or has died?",
        "Existe (rellenar sus datos)": "Exists (fill in their details)",
        "No existe": "Does not exist",
        "Fallecido": "Deceased",
        "Sexo": "Sex",

        // Documentación
        "Documentación que se adjunta": "Attached documentation",
        "Se añaden al final del PDF en páginas nuevas: primero el DNI, luego el libro de familia y por último la resolución": "Appended at the end of the PDF on new pages: ID card first, then the family book and finally the resolution",
        "DNI / NIE · anverso": "ID card · front",
        "DNI / NIE · reverso": "ID card · back",
        "Libro de familia": "Family book",

        // Paso 1: lectura del libro de familia
        "Sube todas las páginas con datos": "Upload every page that has details",
        "Puedes escanear el libro abierto, de dos en dos: el lector busca todas las fichas de persona que haya en cada imagen. Sáltate las páginas en blanco y la tapa.": "You can scan the book open, two pages at a time: the reader looks for every person entry in each image. Skip blank pages and the cover.",
        "No pasa nada si una página sale repetida en dos escaneos: las fichas duplicadas se descartan solas.": "It does not matter if a page appears in two scans: duplicate entries are discarded automatically.",
        "Formatos aceptados": "Accepted formats",
        "Los PDF no valen.": "PDFs are not valid.",
        "Páginas del libro de familia": "Family book pages",
        "Selecciona todas las páginas de una vez": "Select all the pages at once",
        "Se guardan para anexarlas al final del PDF, así que no hará falta volver a subirlas.": "They are kept to append at the end of the PDF, so there is no need to upload them again.",
        "Todavía no has seleccionado ninguna página": "You have not selected any page yet",
        "Leyendo las imágenes...": "Reading the images...",
        "Hay archivos con un formato que el lector no acepta y se han descartado": "Some files have a format the reader does not accept and were discarded",
        "Puedes volver a intentarlo o rellenar el formulario a mano.": "You can try again or fill in the form by hand.",
        "Error desconocido": "Unknown error",
        "¿Prefieres no usar el lector?": "Would you rather not use the reader?",
        "Rellenar el formulario a mano": "Fill in the form by hand",

        // Resumen de la lectura
        "Volver a subir": "Upload again",
        "Solicitante": "Applicant",
        "Otro progenitor": "Other parent",
        "Sin clasificar": "Unclassified",
        "colócalo tú a mano": "place it yourself by hand",
        "(sin nombre)": "(no name)",
        "No se pudo leer": "Could not read",
        "No se ha podido extraer nada de las imágenes.": "Nothing could be extracted from the images.",
        "Revísalo y corrige lo que haga falta.": "Review it and correct whatever is needed.",
        "hay que teclearlos.": "they have to be typed in.",
        "El impreso solo admite 6 hijos: se han descartado los sobrantes": "The form only allows 6 children: the extra ones were discarded",
        "Las páginas del paso anterior ya están aquí: usa el campo solo para añadir alguna más": "The pages from the previous step are already here: use the field only to add more",

        // Lugar y fecha
        "Lugar y fecha": "Place and date",
        "Lugar": "Place",
        "Localidad": "Town",
        "Fecha de la solicitud": "Application date",

        // Envío
        "Generar documentos": "Generate documents",
        "Generando...": "Generating...",
        // Paso 3: revision antes de firma
        "Revisa los documentos antes de": "Review the documents before",
        "enviarlos a firma": "sending them for signature",
        "Documentos que se envían a firma": "Documents sent for signature",
        "Previsualízalos antes de mandarlos: una vez enviados, el cliente los recibe tal cual": "Preview them before sending: once sent, the client receives them as they are",
        "Copia editable": "Editable copy",
        "Descargado en tu equipo. No se envía a firma: está para que puedas corregir el contrato si algo no cuadra, exportarlo a PDF y sustituirlo arriba.": "Downloaded to your computer. Not sent for signature: it is there so you can fix the contract if something is off, export it to PDF and replace it above.",
        "Previsualizar": "Preview",
        "Ocultar previsualización": "Hide preview",
        "¿Quieres corregir alguno de los PDF?": "Do you need to fix any of the PDFs?",
        "El documento sustituido conserva su nombre, así que el envío a firma no cambia": "The replaced document keeps its name, so the signature request is unaffected",
        "Sustituir por otro PDF": "Replace with another PDF",
        "sustituido por": "replaced by",
        "Documento sustituido": "Document replaced",
        "Enviar a firma": "Send for signature",
        "Enviando...": "Sending...",
        "Sin número de negocio no hay expediente al que asociar la firma: los documentos ya están descargados en tu equipo.": "Without a business number there is no case to attach the signature to: the documents are already downloaded to your computer.",
        "No se ha podido enviar a firma. Los documentos siguen descargados en tu equipo.": "Could not send for signature. The documents are still downloaded to your computer.",
        "Documentos generados correctamente": "Documents generated successfully",
        "Los documentos se han descargado en tu equipo": "The documents have been downloaded to your computer",
        "¡Listo!": "Done!",

        // Complemento, DNI del solicitante y lectura conjunta
        "Complemento": "Supplement",
        "Son excluyentes: el impreso solo deja marcar uno": "They are mutually exclusive: the form only allows one",
        "Brecha de género": "Gender gap",
        "Maternidad": "Maternity",
        "DNI del solicitante": "Applicant's ID card",
        "Se lee para rellenar sus datos, y se anexa al PDF junto al libro de familia": "It is read to fill in their details, and appended to the PDF alongside the family book",
        "Sin el reverso no se puede sacar el domicilio": "Without the back, the address cannot be extracted",
        "Leer la documentación": "Read the documents",
        "Sube el libro de familia, el DNI, o los dos": "Upload the family book, the ID card, or both",
        "No se ha podido leer la documentación": "The documents could not be read",
        "Del libro de familia se extraen nombre, apellidos y fecha de nacimiento de cada hijo y del otro progenitor.": "From the family book: first name, surnames and date of birth of each child and of the other parent.",
        "Del DNI se extraen el número, el nombre, los apellidos y el domicilio del solicitante.": "From the ID card: the applicant's number, first name, surnames and address.",
        "No se ha podido leer el DNI: rellena sus datos a mano": "The ID card could not be read: fill in the details by hand",
        "Lo que se ha leído de la documentación": "What was read from the documents",
        "Domicilio": "Address",
        "Los DNI de los hijos no vienen en ningún documento": "The children's ID numbers are not in any document",

        // Visor de documentos
        "Documentación subida": "Uploaded documents",
        "Pulsa una imagen para ampliarla y comprobar los datos sin salir del formulario": "Click an image to enlarge it and check the data without leaving the form",
        "Ver escaneo": "View scan",
        "Alejar": "Zoom out",
        "Acercar": "Zoom in",
        "Girar": "Rotate",
        "Cerrar": "Close",
        "Anterior": "Previous",
        "Siguiente": "Next",
        "Rueda o +/− para el zoom · arrastra para mover · doble clic para acercar · ←/→ para cambiar · 0 para reiniciar": "Wheel or +/− to zoom · drag to pan · double-click to zoom in · ←/→ to switch · 0 to reset",

        // Documento de resolución
        "Resolución": "Resolution",
        "No se lee ni se valida: se adjunta tal cual al final del PDF. Admite imagen o PDF de varias páginas": "Not read or validated: appended as-is at the end of the PDF. Accepts an image or a multi-page PDF",
    }
};
